import Svg, { Path } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { memo } from 'react';
const SvgInfo = (props: SvgProps) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={800} height={800} viewBox="0 0 16 16" {...props}>
    <Path fill="currentColor" d="M6 5h4v11H6V5zM10 2a2 2 0 1 1-3.999.001A2 2 0 0 1 10 2z" />
  </Svg>
);
const Memo = memo(SvgInfo);
export default Memo;
